module.exports = __webpack_public_path__ + "static/media/ic_visa.d825fffd.svg";